/// <reference types="@angular/localize" />

import {enableProdMode, importProvidersFrom} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {environment} from './environments/environment';
import {Router, provideRouter, withHashLocation} from '@angular/router';
import {appPaths} from './app/app-routes';
import {authPaths, authRoutes} from './app/features/auth/shared/auth-routes';
import {AuthHttpInterceptor} from './app/shared/interceptors/auth-http.interceptor';
import {Error404PageComponent} from './app/shared/pages/error404-page/error404-page.component';
import {AuthService} from './app/features/auth/shared/services/auth.service';
import {DOCUMENT} from '@angular/common';
import {APP_CONFIG, AppConfig} from './app/configs/app.config';
import {enableElfProdMode} from '@ngneat/elf';
import {userPaths} from './app/features/user/shared/user-routes';
import {AuthRepository} from './app/features/auth/store/auth.repository';
import {RECAPTCHA_V3_SITE_KEY} from 'ng-recaptcha';
import {profilePaths} from './app/features/profile/shared/profile-routes';
import {benefitsPaths} from './app/features/benefit/shared/benefit-routes';
import {notificationPaths} from './app/features/notification/pages/shared/notificacion-routes';
import {sighuPaths} from './app/features/sighu/shared/sighu-routes';
import {certificatePaths} from './app/features/certificates/shared/certificate-routes';
import {galleryPaths} from './app/features/gallery/pages/shared/gallery-routes';

if (environment.production) {
  enableProdMode();
  enableElfProdMode();
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('custom-sw.js');
  });
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(HttpClientModule),
    provideRouter(
      [
        {
          path: appPaths.home,
          // component: AuthLayoutComponent,
          redirectTo: authRoutes.logIn,
          pathMatch: 'full',
        },
        {
          path: authPaths.base,
          ///component: BlankLayoutComponent,
          loadChildren: () =>
            import('./app/features/auth/auth.routes').then(
              mod => mod.AUTH_ROUTES
            ),
        },
        {
          path: userPaths.user,
          loadChildren: () =>
            import('./app/features/user/user.routes').then(
              mod => mod.USER_ROUTES
            ),
        },
        {
          path: profilePaths.base,
          loadChildren: () =>
            import('./app/features/profile/profile.routes').then(
              mod => mod.PROFILE_ROUTES
            ),
        },
        {
          path: benefitsPaths.base,
          loadChildren: () =>
            import('./app/features/benefit/benefits.routes').then(
              mod => mod.BENEFIT_ROUTES
            ),
        },
        {
          path: sighuPaths.base,
          loadChildren: () =>
            import('./app/features/sighu/sighu.routes').then(
              mod => mod.SIGHU_ROUTES
            ),
        },
        {
          path: certificatePaths.base,
          loadChildren: () =>
            import('./app/features/certificates/certificates.routes').then(
              mod => mod.CERTIFICATE_ROUTES
            ),
        },
        {
          path: galleryPaths.base,
          loadChildren: () =>
            import('./app/features/gallery/gallery.routes').then(
              mod => mod.GALLERY_ROUTES
            ),
        },
        {
          path: notificationPaths.base,
          loadChildren: () =>
            import('./app/features/notification/notificacion.routes').then(
              mod => mod.NOTIFICATION_ROUTES
            ),
        },
        {
          path: '404',
          component: Error404PageComponent,
        },
        {
          path: '**',
          redirectTo: '404',
        },
      ],
      withHashLocation()
    ),
    {provide: APP_CONFIG, useValue: AppConfig},
    {provide: Document, useExisting: DOCUMENT},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
      deps: [Router, AuthService, AuthRepository, DOCUMENT],
    },
    {provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCaptchaV3.siteKey},
  ],
}).catch(err => console.error(err));
